import './services-card-2.sass';
import { Container, Row, Col, Image, Button } from 'react-bootstrap';
import image15 from '../../assets/images/image15.png';
import { Trans } from 'react-i18next';

function Services_card_2() {
  return (
    <Container fluid className="services-card2-container">
      <Row className="g-0">
        <Col md={5} className="left-col-card2">
          <p className="small-title-card2">
            <Trans i18nKey="small_title_card2" />
          </p>
          <h1 className="big-title-card2">
            <Trans i18nKey="big_title_card2" />
          </h1>
          <Button className="button-explore-card2">
            <Trans i18nKey="button_explore_card2" />
          </Button>
        </Col>
        <Col md={7} className="right-col-card2">
          <Image src={image15} alt="" fluid />
        </Col>
      </Row>
    </Container>
  );
}

export { Services_card_2 };
